import type { Entry } from 'contentful';

import { TypeUistringsSkeleton } from '../models/cms';
import { UIStrings } from '../models/UIStrings';

export const transformUIStrings = (skeleton: Entry<TypeUistringsSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>): UIStrings => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { internalName, metadataDescription, metadataTitle, ...rest } = skeleton.fields;

  return rest;
};
